import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { CenterFilter } from "src/app/model/center-filter";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import { ServiceFilter } from "src/app/model/service-filter";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { StudyReportService } from "src/app/services/study-report/study-report.service";
import { StudyReportStateFilter } from "../../../model/study-report-state";
import { PracticeRegionFilter } from "../../../model/practice-region-filter";
import { map } from "rxjs/operators";
import { Entity } from "../../../model/entity/entity";
import { StatusPhotography } from "../../../model/status-photography";
import { MedicalServiceService } from "../../../services/medical-service.service";
import { StudyRegionFilter } from "../../../model/study-report/study-region-filter";

@Component({
  selector: "app-study-report-control-filter",
  templateUrl: "./study-report-control-filter.component.html",
  styleUrls: ["./study-report-control-filter.component.css"],
})
export class StudyReportControlFilterComponent
  implements IFilterComponent, OnInit
{
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteStudyReportPhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePractices: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteStatusPhotography: FilterCompleteService<StatusPhotography>;
  filterCompleteStudyRegion: FilterCompleteService<StudyRegionFilter>;
  studyReportStates: StudyReportStateFilter[] = [];
  entities: Entity[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private medicalServiceService: MedicalServiceService,
    private studyReportService: StudyReportService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      dateFrom: [null],
      dateTo: [null],
      appointmentDate: [null],
      studyReportRegion: [null],
      patient: [null],
      studyReportPhysician: [null],
      center: [null],
      service: [null],
      protocol: [""],
      practiceRegion: [null],
      entities: [[]],
      studyReportStates: [[]],
      onNoPublish: [false],
      reAppointment: [false],
      withAdminControled: [false],
      orderByDeliveryDate: [false],
      noReportPhysician: [false],
      onlyEndAttention: [false],
      statusPhotography: [null],
      noAdminControled: [false],
      orderByConfirmDate: [false],
      confirmDate: [null],
    });

    this.filterCompleteStudyRegion = new FilterCompleteService<Entity>(
      [],
      this.form.controls.studyReportRegion
    );
    this.filterCompletePractices =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.practiceRegion
      );
    this.filterCompleteServices = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompleteStudyReportPhysicians =
      new FilterCompleteService<PhysicianFilter>(
        [],
        this.form.controls.StudyReportPhysician
      );
    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      [],
      this.form.controls.Center
    );
    this.filterCompleteStatusPhotography =
      new FilterCompleteService<StatusPhotography>(
        [],
        this.form.controls.statusPhotography
      );
  }

  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "StudyReportControlFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "StudyReportControlFilterComponent",
      this.form
    );
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  get filteredStudyReportPhysiciansOptions() {
    return this.filterCompleteStudyReportPhysicians
      ? this.filterCompleteStudyReportPhysicians.filteredOptions
      : [];
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get filteredPracticesOptions() {
    return this.filterCompletePractices
      ? this.filterCompletePractices.filteredOptions
      : [];
  }
  get filteredStatusPhotographyOptions() {
    return this.filterCompleteStatusPhotography
      ? this.filterCompleteStatusPhotography.filteredOptions
      : [];
  }
  get filterCompleteStudyRegionOptions() {
    return this.filterCompleteStudyRegion
      ? this.filterCompleteStudyRegion.filteredOptions
      : [];
  }

  async search(): Promise<any> {
    if (this.form.invalid) return [];

    return await this.studyReportService.getStudyReportSearchItemsForControl(
      this.form.controls.protocol.value,
      this.form.controls.studyReportStates.value != null
        ? this.form.controls.studyReportStates.value.map((s) => s.Id)
        : [],
      this.form.controls.onNoPublish.value != null
        ? this.form.controls.onNoPublish.value
        : false,
      this.form.controls.noReportPhysician.value != null
        ? this.form.controls.noReportPhysician.value
        : false,
      this.form.controls.withAdminControled.value != null
        ? this.form.controls.withAdminControled.value
        : false,
      this.form.controls.orderByDeliveryDate.value != null
        ? this.form.controls.orderByDeliveryDate.value
        : false,
      this.form.controls.onlyEndAttention.value != null
        ? this.form.controls.onlyEndAttention.value
        : false,
      this.form.controls.reAppointment.value != null
        ? this.form.controls.reAppointment.value
        : false,
      this.form.controls.entities.value != null
        ? this.form.controls.entities.value.map((s) => s.Id)
        : [],
      this.form.controls.patient.value != null
        ? this.form.controls.patient.value.Id
        : null,
      this.form.controls.studyReportRegion.value != null
        ? this.form.controls.studyReportRegion.value.Id
        : null,
      this.form.controls.practiceRegion.value != null
        ? this.form.controls.practiceRegion.value.Id
        : null,
      this.form.controls.dateFrom.value != null
        ? this.form.controls.dateFrom.value
        : null,
      this.form.controls.dateFrom.value != null
        ? this.form.controls.dateTo.value
        : null,
      this.form.controls.appointmentDate.value != null
        ? this.form.controls.appointmentDate.value
        : null,
      this.form.controls.studyReportPhysician.value != null
        ? this.form.controls.studyReportPhysician.value.Id
        : null,
      this.form.controls.center.value != null
        ? this.form.controls.center.value.Id
        : null,
      this.form.controls.service.value != null
        ? this.form.controls.service.value.Id
        : null,
      this.form.controls.statusPhotography.value != null
        ? this.form.controls.statusPhotography.value.Id
        : null,
      this.form.controls.noAdminControled.value != null
        ? this.form.controls.noAdminControled.value
        : null,
      this.form.controls.orderByConfirmDate.value != null
        ? this.form.controls.orderByConfirmDate.value
        : null,
      this.form.controls.confirmDate.value != null
        ? this.form.controls.confirmDate.value
        : null
    );
  }

  allEntitiesSelected: boolean = false;

  toggleAllSelection(entity: Entity) {
    if (entity.Id === 0) {
      this.allEntitiesSelected = !this.allEntitiesSelected;
      if (this.allEntitiesSelected) {
        this.form.controls.entities.setValue(this.entities);
      } else {
        this.form.controls.entities.setValue([]);
      }
    }
  }

  ngOnInit(): void {
    this.medicalServiceService.getStatusPhotography().then((status) => {
      this.filterCompleteStatusPhotography =
        new FilterCompleteService<StatusPhotography>(
          status,
          this.form.controls.statusPhotography
        );
    });

    this.filterService.getPhysiciansFilter().then((physiciansFilter) => {
      this.filterCompleteStudyReportPhysicians =
        new FilterCompleteService<PhysicianFilter>(
          physiciansFilter,
          this.form.controls.studyReportPhysician
        );
    });

    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
        centers,
        this.form.controls.center
      );
    });

    this.medicalServiceService.getStudyRegionFilter().then((regions) => {
      this.filterCompleteStudyRegion =
        new FilterCompleteService<StudyRegionFilter>(
          regions,
          this.form.controls.studyReportRegion
        );
    });

    this.filterService.getEntitiesFilter(true).then((entities) => {
      this.entities = entities;
      this.allEntitiesSelected = false;
      this.form.controls.entities.setValue([]);
      const entityTodas = new Entity();
      entityTodas.Id = 0;
      entityTodas.Name = "Todas";
      this.entities.unshift(entityTodas);
    });

    this.filterService.getServicesFilter().then((services) => {
      this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
        services,
        this.form.controls.service
      );
    });

    this.filterService.getPracticesRegionFilter().then((practices) => {
      this.filterCompletePractices =
        new FilterCompleteService<PracticeRegionFilter>(
          practices,
          this.form.controls.practiceRegion
        );
    });

    this.studyReportService.getStudyReportStateFilters().then((states) => {
      this.studyReportStates = states;
    });
  }
}
